import { create, StateCreator } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { AuthenticatedUser, IncompleteUser } from './types';

type AuthSlice = {
  isAuthorized: boolean;
  accessToken: string | null;
  user: AuthenticatedUser | null;
  setUser: (user: AuthenticatedUser | null) => void;
  login: (accessToken: AuthSlice['accessToken'], user: IncompleteUser) => void;
  logout: () => void;
};

const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  isAuthorized: false,
  accessToken: null,
  user: null,
  setUser: (user: AuthenticatedUser | null) => set(() => ({ user })),
  login: (accessToken: AuthSlice['accessToken'], user: IncompleteUser) =>
    set(() => ({
      isAuthorized: true,
      accessToken,
      user,
    })),
  logout: () =>
    set(() => ({ isAuthorized: false, accessToken: null, user: null })),
});

export const useAuthStore = create<AuthSlice>()(
  devtools(
    persist((...a) => ({ ...createAuthSlice(...a) }), { name: 'user-storage' }),
  ),
);
